module.exports = __webpack_public_path__ + "img/03.d1cd3f73.png";